import EditableDetailsCardWrapper from "entity-app/shared-components/editable-details-card-wrapper/editable-details-card-wrapper";
import { useContext, useMemo } from "react";
import FeatureAttachments from "components/feature-attachments";
import FeatureActivityCard from "components/feature-activity-card/feature-activity-card";
import {
  isPermissionNotGrantted,
  ProjectContext,
  TProjectContext
} from "context/ProjectProvider";
import { ProjectPermissionEnum } from "constants/index";
import { TFetureDetailUpdateAction } from "entity-app/models";
import { ErrorBoundary } from "@sentry/react";
import CustomFields from "components/custom-fields";
import { FeatureTypes } from "entity-app/constants";
import BidPackageEdtableGeneralInfo from "./components/bid-package-editable-general-info";
import Participants from "./components/participants";
import OwnersInfo from "./components/owners-info";
import FeatureLinkedTopSection from "./components/faeture-linked-top-section";

function BidPackageDetails(props: {
  featureInstanceData: any;
  actions: TFetureDetailUpdateAction;
  featureId: string;
}) {
  const { featureInstanceData, actions, featureId } = props;
  const {
    tokenContents,
    columnHeaders: { bidPackageCustomColumns },
    isFeatureFlagEnabled,
    isProjectArchived
  }: TProjectContext = useContext(ProjectContext);

  const isAttachementFeatureEnabled =
    !isFeatureFlagEnabled("DISABLE_ATTACHMENT");

  const permissionsForActivityCard = useMemo(() => {
    return isProjectArchived ? [] : ["create_comment"];
  }, [isProjectArchived]);

  const cannotWriteAccessOfBidPackage = isPermissionNotGrantted(
    ProjectPermissionEnum.BidPackageWrite,
    tokenContents?.role ?? ""
  );

  return (
    <div className="flex flex-col p-4 space-y-4">
      <FeatureLinkedTopSection
        actions={actions}
        featureInstanceData={featureInstanceData}
        disabled={cannotWriteAccessOfBidPackage}
      />
      <div className="grid grid-cols-3 gap-4 pb-10">
        <div className="flex flex-col gap-4">
          <EditableDetailsCardWrapper title="General Information">
            <BidPackageEdtableGeneralInfo
              featureInstanceData={featureInstanceData}
              actions={actions}
              disabled={cannotWriteAccessOfBidPackage}
            />
          </EditableDetailsCardWrapper>
          <EditableDetailsCardWrapper title="Bid Details">
            <Participants
              featureInstanceData={featureInstanceData}
              actions={actions}
              disabled={cannotWriteAccessOfBidPackage}
            />
          </EditableDetailsCardWrapper>
        </div>
        <div className="h-[800px] flex flex-col gap-y-4">
          <FeatureActivityCard
            historyTabContents={<div>History</div>}
            featureId={featureId}
            featureKey="feature_instance_id"
            permissions={permissionsForActivityCard}
            isAttachementFeatureEnabled={isAttachementFeatureEnabled}
            showHistoryTab={false}
            auditFeatureType="BID_PACKAGE"
          />
        </div>
        <div className="flex flex-col gap-y-4">
          <div className="h-[391px]">
            <EditableDetailsCardWrapper title="Leads">
              <OwnersInfo
                featureInstanceData={featureInstanceData}
                actions={actions}
                disabled={cannotWriteAccessOfBidPackage}
              />
            </EditableDetailsCardWrapper>
          </div>
          {isAttachementFeatureEnabled && (
            <div className="h-[391px]">
              <EditableDetailsCardWrapper title="Attachments">
                <FeatureAttachments
                  featureId={featureId}
                  featureInstanceData={featureInstanceData}
                  auditFeatureType="BID_PACKAGE"
                />
              </EditableDetailsCardWrapper>
            </div>
          )}
        </div>
        {bidPackageCustomColumns?.length > 0 && (
          <EditableDetailsCardWrapper
            title="Others"
            data-testid="material-detail-cards-others-wrapper"
          >
            <ErrorBoundary>
              <CustomFields
                featureInstanceData={featureInstanceData}
                data-testid="bid-package-detail-cards-others"
                type={FeatureTypes.BID_PACKAGE}
                columns={bidPackageCustomColumns}
                disabled={!!isProjectArchived}
              />
            </ErrorBoundary>
          </EditableDetailsCardWrapper>
        )}
      </div>
    </div>
  );
}

export default BidPackageDetails;
